import Select from "react-select";
import React, {useEffect, useState} from "react";
import {SelectOptionType} from "Model/Select/SelectOption";

interface Props {
    onChange: (newValue: SelectOptionType|null) => void,
    onLoad?: (activities: any[]) => void,
    value?: any,
    classes?: string,
    filters?: {[key:string]:string|number}
    defaultOptions: any
    isLoading: boolean
}

export const TutorSelect : React.FC<Props> = (props) => {

    const [options, setOptions] = useState<any>([])

    useEffect(() => {
        setOptions(props.defaultOptions)
    }, [props.defaultOptions]);

    return (
        <Select
            isLoading={props.isLoading}
            value={props.value ?? null}
            options={options}
            placeholder={""}
            noOptionsMessage={() => "No hay resultados"}
            isClearable={true}
            loadingMessage={() => "Cargando ..."}
            onChange={props.onChange}
            className={props.classes ?? ''}
        />
    )
}
